module.exports = __webpack_public_path__ + "static/media/feat-cumberland-hero.2bee9b24.jpg";